import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FTSFilterWrapperRadio = _resolveComponent("FTSFilterWrapperRadio")!

  return (_openBlock(), _createBlock(_component_FTSFilterWrapperRadio, {
    modelValue: _ctx.sectionAccessor,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.sectionAccessor) = $event)),
    options: _ctx.getWeightOptions,
    name: "section"
  }, null, 8, ["modelValue", "options"]))
}